// eslint-disable-next-line import/prefer-default-export
export const MAJ_TVA = {
  actionLibelle: 'Modifier la TVA',
  title: 'Modification de la TVA',
  message: 'Action sur la TVA',
  problemAddOccurred: 'La modification est impossible : ',
  actions: {
    cancel: 'Annuler',
    validate: 'Appliquer',
  },
  error: {
    title: 'Modification interdite',
    pourcentage: 'La TVA est obligatoire',
  },
};
